import { useRouter } from 'next/router';

export const useStepIndex = () => {
  const router = useRouter();
  const { pathname, query } = router;

  if (pathname === '/services') {
    return 0;
  }

  if (pathname === '/book') {
    switch (query.step) {
      case 'select-time':
        return 1;
      case 'select-location':
        return 1;
      case 'personal-info':
        return 2;
      case 'payment':
        return 2;
    }

    return 1;
  }

  return -1;
};
